import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Input from './Input';

export const Container = styled.div`
  margin-bottom: 55px;
`;

export const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.colors.borderError};
  font-size: 12px;
  margin-top: 5px;
`;

export default class InputWithError extends PureComponent {
  static propTypes = {
    errorMessage: PropTypes.string,
  };

  static defaultProps = {
    errorMessage: '',
  };

  render() {
    const { errorMessage, ...props } = this.props;

    return (
      <Container>
        <Input {...props} />
        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      </Container>
    );
  }
}
